import type { QuestDifficulty } from '../types/quest';

/**
 * Product decision: keep rewards simple for launch.
 *
 * Virtual purchases (shop items, avatar accessories, purchasable themes,
 * consumable power-ups, and shop-gated games) are held for now. The reward
 * loop should point kids toward earned game/arcade time instead.
 */
export const VIRTUAL_REWARD_ECONOMY_ENABLED = false;

export function questArcadeMinutes(difficulty: QuestDifficulty): number {
  switch (difficulty) {
    case 'hard':
      return 3;
    case 'medium':
      return 2;
    default:
      return 1;
  }
}
